<template>
  <div class="postavitev-info">
    <div class="info-okvir">
      <div class="postavitev-info-icone">
        <i class="fa fa-info-circle"></i>
      </div>
      <div class="postavitev-info-tekst">
        <p class="modra-barva-info">
          Naročniki T-2 storitev, ki ste doslej uporabljali uporabniški portal Horizont, lahko uporabite možnost
          enostavne povezave naročnine v portal MOJ T-2 s pomočjo svojih obstoječih prijavnih podatkov iz portala
          Horizont. V primeru, da se s T-2 uporabniškim portalom srečujete prvič, prosimo, uporabite povezavo
          naročnine z novimi podatki.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'InfoKomponentaDodajanjeNarocnin'
}
</script>

<style scoped>
.postavitev-info {
  padding-top: 40px;
}

.info-okvir {
  width: 750px;
  height: 120px;
  display: flex;
}

@media only screen and (max-width: 1660px) {
  .info-okvir {
    width: 100%;
    height: 100%;
  }

  .postavitev-info {
    padding-top: 30px;
    padding-bottom: 45px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/DodajanjeNarocnin/DodajanjeNarocninKomponente/InfoKomponentaDodajanjeNarocnin.vue